const constants = {
  EXERCISE_LOADING_START: 'EXERCISE_LOADING_START',
  EXERCISE_LOADING_END: 'EXERCISE_LOADING_END',
  EXERCISE_LOAD: 'EXERCISE_LOAD',
  EXERCISE_UPDATE: 'EXERCISE_UPDATE',
  EXERCISE_CLEAR: 'EXERCISE_CLEAR',
  EXERCISE_RENAME_USER: 'EXERCISE_RENAME_USER',
  EXERCISE_STATUS_CHANGE: 'EXERCISE_STATUS_CHANGE',
  EXERCISE_USER_STATUS_CHANGE: 'EXERCISE_USER_STATUS_CHANGE',
  EXERCISE_USER_LEFT: 'EXERCISE_USER_LEFT',
  EXERCISE_USER_JOINED: 'EXERCISE_USER_JOINED',
  EXERCISE_LOCATION_UPDATE: 'EXERCISE_LOCATION_UPDATE',
  EXERCISE_SET_STATE: 'EXERCISE_SET_STATE',
  EXERCISE_SET_VAR: 'EXERCISE_SET_VAR',
  EXERCISE_SET_VAR_LOG: 'EXERCISE_SET_VAR_LOG',
  EXERCISE_PLAY_START: 'EXERCISE_PLAY_START',
  EXERCISE_PLAY_PAUSE: 'EXERCISE_PLAY_PAUSE',
  EXERCISE_PLAY_STOP: 'EXERCISE_PLAY_STOP',
  EXERCISE_PLAY_UPDATE_TIME: 'EXERCISE_PLAY_UPDATE_TIME',
  EXERCISE_SET_BENCHMARK: 'EXERCISE_SET_BENCHMARK',
};

export default constants;
